import type { OrganizationSkill } from '@renderer/chat/hooks/use-organization-skills'
import type { SwitchableOrganization } from '@renderer/windows/features/people/hooks/use-organizations'

export type OrganizationDirectoryState =
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'empty' }
  | { status: 'ready'; skills: Array<OrganizationSkill> }

export function getTeamOrganizations(organizations: Array<SwitchableOrganization>): Array<SwitchableOrganization> {
  return organizations.filter((organization) => !organization.isPersonal)
}

export function isOrganizationSkillOwner(skill: OrganizationSkill, userId: string | null): boolean {
  return userId !== null && skill.userId === userId
}

export function getOrganizationDirectoryState({
  skills,
  isPending,
  isError,
}: {
  skills: Array<OrganizationSkill> | undefined
  isPending: boolean
  isError: boolean
}): OrganizationDirectoryState {
  if (isPending) {
    return { status: 'loading' }
  }

  if (isError) {
    return { status: 'error' }
  }

  if (!skills?.length) {
    return { status: 'empty' }
  }

  return { status: 'ready', skills }
}
